// extracted by mini-css-extract-plugin
export default {"closeButtonContainer":"PaymentStatus_closeButtonContainer__3dhbs","modalContent":"PaymentStatus_modalContent__lU-Lx","title":"PaymentStatus_title__DPcS2"};